// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreOrderSet = (client) => ({
    /**
     * `GET /store/order-set`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListOrderSets
     * @source packages/modules/b2c-core/src/api/store/order-set/route.ts
     */
    list: (query, headers) => client.fetch("/store/order-set", { method: "GET", query, headers }),
    /**
     * `GET /store/order-set/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreOrderSetIdRetrieve
     * @source packages/modules/b2c-core/src/api/store/order-set/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/order-set/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=order-set.js.map